import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';
import { ClientId } from '../utils/constants';
import { getFeaturesByClientId } from '../utils/getFeaturesByClientId';
import { actually } from '../utils/logging';
import { getPersistedParameters } from '../utils/persistParameterContext';

export function usePreventAutoSignIn(clientId?: ClientId) {
  const [isAutoSignInPrevented, setAutoSignInPrevented] = useState(false);
  const { flags, areFlagsLoaded } = useFeatureFlagsValue();

  useEffect(() => {
    if (!areFlagsLoaded) return;

    let resolvedClientId = clientId;
    if (!resolvedClientId) {
      const params = getPersistedParameters();
      resolvedClientId = params?.client_id as ClientId;
    }

    const { isEligibleToPreventAutoSignIn } = getFeaturesByClientId(resolvedClientId);
    const flagValue = flags?.find(v => v?.flagKey === FEATURE_FLAGS.PREVENT_AUTO_SIGN_IN?.toString())?.flagValue;

    // Flag value is a JSON array of client IDs that should have auto-sign-in prevented.
    // e.g. ["holiday_gift_shop", "passkey"] or [] (empty = use hardcoded isEligibleToPreventAutoSignIn)
    let flag = isEligibleToPreventAutoSignIn;

    if (flagValue) {
      try {
        const parsedClients: string[] = JSON.parse(JSON.stringify(flagValue));

        if (Array.isArray(parsedClients) && parsedClients.length > 0) {
          // Non-empty array: check if this client is in the list
          flag = parsedClients.includes(resolvedClientId as string);
        }
      } catch (error) {
        actually.error('usePreventAutoSignIn - Failed to parse FF value', error);
      }
    }

    setAutoSignInPrevented(flag);
  }, [flags, areFlagsLoaded, clientId]);

  return { isAutoSignInPrevented, areFlagsLoaded };
}
